import {combineReducers, Reducer} from 'redux'
import {QuizzesState} from '@models/quiz'
import {QuizzesActionTypes} from '@actions/quiz';


// Type-safe initialState!
export const initialState: QuizzesState = {
  allIds: [],
  byId: {},
  loading: false,
  count: 0
};


const byId = (state = initialState.byId, action) => {
  switch (action.type) {
    case QuizzesActionTypes.FETCH_SUCCESS: {
      const {data} = action.payload;
      return {
        ...data.reduce((obj, quiz) => {
          obj[quiz.id] = {
            ...quiz,
            ...(state[quiz.id] || {}), //The data which fetch by id is more than data in Table
          };
          return obj;
        }, {})
      };
    }
    
    case QuizzesActionTypes.CREATE_SUCCESS: {
      const quiz = action.payload;
      return {
        ...state,
        [quiz.id]: quiz
      };
    }
    
    case QuizzesActionTypes.UPDATE_SUCCESS: {
      const quiz = action.payload;
      return {
        ...state,
        [quiz.id]: {
          ...state[quiz.id],
          ...quiz
        }
      };
    }
    
    case QuizzesActionTypes.FETCH_ITEM_SUCCESS: {
      const quiz = action.payload;
      return {
        ...state,
        [quiz.id]: {
          ...state[quiz.id],
          ...quiz,
          is_fetched: true
        },
      };
    }
    
    case QuizzesActionTypes.DELETE_SUCCESS:
      return Object.keys(state)
        .filter(id => id !== action.payload.id)
        .reduce((result, current) => {
          result[current] = state[current];
          return result;
        }, {});
    
    
    default:
      return state;
  }
};


const allIds = (state = initialState.allIds, action) => {
  switch (action.type) {
    case QuizzesActionTypes.FETCH_SUCCESS: {
      const {data} = action.payload;
      return data.map(item => item.id);
    }
    
    case QuizzesActionTypes.DELETE_SUCCESS:
      const deletedFormIndex = state.indexOf(action.payload.id);
      return [...state.slice(0, deletedFormIndex), ...state.slice(deletedFormIndex + 1)];
    
    case QuizzesActionTypes.CREATE_SUCCESS:
      return [action.payload.id, ...state];
    
    default:
      return state
  }
};


const count = (state = initialState.count, action) => {
  switch (action.type) {
    case QuizzesActionTypes.FETCH_SUCCESS: {
      const {meta} = action.payload;
      return meta.total_count;
    }
    
    case QuizzesActionTypes.DELETE_SUCCESS:
      return state - 1;
    
    case QuizzesActionTypes.CREATE_SUCCESS:
      return state + 1;
    
    
    default:
      return state
  }
};

const loading = (state = initialState.loading, action) => {
  switch (action.type) {
    case QuizzesActionTypes.FETCH_REQUEST: {
      return true;
    }
    
    case QuizzesActionTypes.FETCH_SUCCESS:
    case QuizzesActionTypes.FETCH_ERROR:
      return false;
    
    default:
      return state
  }
};


const reducer: Reducer<QuizzesState> = combineReducers({
  byId,
  allIds,
  count,
  loading
});

export {reducer as quizReducer}


//Selectors
export const getQuizzesList = quizzes => quizzes.allIds.map(id => quizzes.byId[id]);

export const getQuizById = (quizzes, id) => quizzes.byId[id];